export const options = [
  {label: 'Casado(a)', value: "C" },
  {label: 'Divorciado(a)', value: "D" },
  {label: 'Solteiro(a)', value: "S" },
  {label: 'Viúvo(a)', value: "V" },
];